<template>
    <form action="" ref="registerForm"  v-on:submit.prevent="setUpFormData" class="needs-validation pt-3 bg-black">
        <div class="form-group row" v-if="childPasses">
                <div class="col-md-12">
                    <div class="form-group d-flex">
                        <input type="checkbox" id="child" name="child" value="false" class="mt-1 form-control" style="font-size: 0.4rem;box-shadow: 0px 0px 0px !important; width: 5%;" v-model="child">
                        <label for="child" class="pl-0 pt-1 border-0 form-check-label form-control" style="font-size: 1.1em;">Check here if this pass is for a child. Child passes do not require an email.  Please use an attending gaurdian's phone number.</label>
                    </div>
                </div>
        </div>
        <div class="col-12 mb-4">
            <div class="alert-danger border border-danger col-12 danger font-weight-bold mb-4 p-3 text-dark" v-if="errors.length > 0"> {{ errors[0] }}</div>
            <h4 class="font-weight-bold">Update Attendee: {{attendee.prefix}} {{attendee.first_name}} {{attendee.last_name}} {{attendee.suffix}}</h4>
            <div class="form-group row">
                <div class="col-md-6">
                    <label for="category" class="col-form-label">Location Attending</label>
                    <select class="form-control form-select" id="location" name="location" required v-model="attendee.location">
                        <option selected >Please Choose</option>
                        <option value="oh" v-if="attendee.location == 'oh' || ohAvailable > 0" >Columbus, OH</option>
                        <option value="tx" v-if="attendee.location == 'tx' || txAvailable > 0" >Fort Worth, TX</option>
                        <option value="co" v-if="attendee.location == 'co' || coAvailable > 0" >Denver, CO</option>
                    </select>
                </div>
                <div class="col-md-6">
                        <label class="col-form-label pt-4 pb-0 w-100">Will this person be our on site point-of-contact?</label>
                        <div class="form-check-inline">
                            <label class="form-check-label" for="onsite_contact">
                                <input type="radio" class="form-check-input"  v-model="attendee.onsite_contact" name="onsite_contact" value="1">Yes</input>
                            </label>
                        </div>
                        <div class="form-check-inline">
                            <label class="form-check-label" for="onsite_contact">
                                <input type="radio" class="form-check-input"  v-model="attendee.onsite_contact" name="onsite_contact" value="0" checked>No</input>
                            </label>
                        </div>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-md-2">
                    <label for="prefix" class="col-form-label text-md-left">Prefix</label>
                    <div class="">
                        <select class="form-control form-select" id="prefix" v-model="attendee.prefix">
                        <option value=""></option>
                        <option value="Mr.">Mr.</option>
                        <option value="Mrs.">Mrs.</option>
                        <option value="Ms.">Ms.</option>
                        <option value="Miss">Miss</option>
                        <option value="Fr.">Fr.</option>
                        <option value="Sr.">Sr.</option>
                        <option value="Br.">Br.</option>
                        <option value="Rev.">Rev.</option>
                        <option value="Msgr.">Msgr.</option>
                    </select>
                    </div>
                </div>
                <div class="col-md-4">
                    <label for="first_name" class="col-form-label text-md-left">First Name</label>
                    <div class="">
                        <input type="text"  v-model="attendee.first_name" id="first_name" class="form-control"  maxlength="100" required autofocus autocomplete="first_name" />
                    </div>
                </div>
                <div class="col-md-4">
                    <label for="last_name" class="col-form-label text-md-left">Last Name</label>
                    <div class="">
                        <input type="text"  v-model="attendee.last_name" id="last_name" class="form-control"  maxlength="100" required autofocus autocomplete="last_name" />
                    </div>
                </div>
                <div class="col-md-2">
                    <label for="suffix" class="col-form-label text-md-left">Suffix</label>
                    <div class="">
                        <input type="text"  v-model="attendee.suffix" id="suffix" class="form-control" maxlength="100" autofocus autocomplete="suffix" />
                    </div>
                </div>
            </div><!--form-group-->

             <div class="form-group row" v-if="child">
                <div class="col-md-5">
                    <div class="">
                        <input type="hidden"  v-model="attendee.email" id="email" class="form-control"  maxlength="100" required autofocus autocomplete="email" />
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="">
                        <input type="hidden"  v-model="attendee.confirm" id="confirm_email" class="form-control"  maxlength="100" required autofocus autocomplete="email" />
                    </div>
                </div>
            </div>
            <div class="form-group row" v-else>
                <div class="col-md-6">
                    <label for="email" class="col-form-label text-md-left">Attendee Email</label>
                    <div class="">
                        <input type="text"  v-model="attendee.email" id="email" class="form-control"  maxlength="100" required autofocus autocomplete="email" />
                    </div>
                </div>
                <div class="col-md-6">
                    <label for="email" class="col-form-label text-md-left">Confirm Email</label>
                    <div class="">
                        <input type="text"  v-model="attendee.confirm" id="confirm_email" class="form-control"  maxlength="100" required autofocus autocomplete="email" />
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-6">
                    <label for="phone" class="col-form-label text-md-left">Attendee Phone Number</label>
                    <div class="">
                        <input type="tel"  v-model="attendee.phone" id="phone" class="form-control"  maxlength="100" autofocus autocomplete="phone" />
                    </div>
                </div>
                <div class="col-md-6">
                    <label for="category" class="col-form-label">Dietary Preferences</label>
                    <select class="form-control form-select" id="diet" v-model="attendee.diet">
                        <option value="Standard" selected >Standard</option>
                        <option value="Gluten Free">Gluten Free</option>
                        <option value="Vegetarian">Vegetarian</option>
                        <option value="Dairy Free">Dairy Free</option>
                        <option value="Gluten and Dairy Free">Gluten & Dairy Free</option>
                    </select>
                </div>
            </div>
            <div class="form-row row">
                 <div class="col-12 d-flex justify-content-between">
                    <a data-toggle="collapse" :href="'#attendeeEdit'+attendee.id" class="btn btn-sm my-3 w-25">Cancel</a>
                    <button  type="submit" class="btn btn-primary btn-sm my-3 w-25">UPDATE</button >
                 </div>
            </div>
        </div>
    </form>
</template>

<script>
import {mapState} from 'vuex';
export default {
    mounted() {
        // console.log(this.attendee.diet)
        this.attendee.confirm = this.attendee.email
    },
    props: {
        attendee: Object,
        sponsorship: Number,
        ohAvailable: Number,
        txAvailable: Number,
        coAvailable: Number
    },
    data() {
        return {
            formData: new FormData(),
            child: false,
          }
    },
    computed: {
            ...mapState(['childPasses', 'errors'])
        },
    methods: {
            setUpFormData() {
                for (var key of this.formData.keys()) {
                    console.log('clearing!');
                    this.formData.delete(key)
            };
                this.attendee.email = this.child ? 'ChildAttendee-' + Math.random(2).toFixed(5).toString().substring(2,6)+'@child-no-email.com' : this.attendee.email
                this.prepareAttendee()
            },
            prepareAttendee() {
                this.formData.append('_method', 'PATCH')
                this.formData.append('attending', 1);
                const attendeeData = Object.entries(this.attendee)
                for (let [key, value] of attendeeData) {
                    value = value === null ? '' : value
                    this.formData.append(key, value)
                }

                const payload = {
                    'sponsorship': this.sponsorship,
                    'attendeeData': this.formData
                }
                this.$store.dispatch('updateAttendee', payload)
            },
        },
    }
</script>
<style scoped>
label{
    color: white;
}
</style>
